// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s3Y_Gi{min-height:24px}.f7lAgh{display:grid;min-width:5em}.YbPwKh [data-hook=setup-step-title-text]{text-decoration:line-through}.yEj_MH{pointer-events:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `s3Y_Gi`,
	"title": `f7lAgh`,
	"titleCrossed": `YbPwKh`,
	"checkboxContainer": `yEj_MH`
};
export default ___CSS_LOADER_EXPORT___;
